import { Navigate, Route, Routes, useParams } from "react-router-dom"
import MemberLayout from "./layout"
import Invoices from "./invoices"
import Events from "./events"
import Show from "./invoices/show"
import Cart from "pages/cart"
import Payment from "./invoices/show/payment"
import Pay from "./invoices/show/payment/pay"
import Discussion from "./discussion"
import NoMatch from "components/no-match"

const Members: React.FC = () => (
  <Routes>
    <Route path=":memberId">
      <Route path="cart" element={<Cart />} />
      <Route element={<MemberLayout />}>
        <Route index element={<Navigate to="events" />} />
        <Route path="events/*" element={<Events />} />
        <Route path="invoices/*">
          <Route index element={<Invoices />} />
          <Route path=":invoiceId">
            <Route index element={<Show />} />
            <Route path="payment/*">
              <Route index element={<Payment />} />
              <Route path="pay_invoice" element={<Pay />} />

              <Route path="*" element={<NoMatch />} />
            </Route>

            <Route path="*" element={<NoMatch />} />
          </Route>
        </Route>
        <Route path="discussion" element={<Discussion />} />
      </Route>

      <Route path="*" element={<NoMatch />} />
    </Route>
  </Routes>
)

function useMemberId() {
  return useParams<"memberId">().memberId
}

function useInvoiceId() {
  return useParams<"invoiceId">().invoiceId
}

export { useMemberId, useInvoiceId }

export default Members
